import React from 'react';
import {ButtonPrimary} from '@homeaway/react-buttons';
import './ErrorMessage.less';
import SvgIcon from './SvgIcon';

export default ({onClose, messages}) => {
    return (
        <figure className="ErrorMessage media-flex__figure">
            <SvgIcon />
            <h2 className="ErrorMessage__title">{messages.multipleUnitsErrorTitle}</h2>
            <p>{messages.multipleUnitsErrorDescription}</p>
            {onClose && (
                <div className="ErrorMessage__close-button-wrapper">
                    <ButtonPrimary
                        className={'ErrorMessage__close-button'}
                        block
                        label={messages.multipleUnitsErrorButton}
                        size="xs"
                        onClick={onClose}
                    />
                </div>
            )}
        </figure>
    );
};
